module.exports = __webpack_public_path__ + "img/download_huawei.628fce18.png";